import { render, staticRenderFns } from "./systemQuality.vue?vue&type=template&id=b8cb97f6&scoped=true&"
import script from "./systemQuality.vue?vue&type=script&lang=js&"
export * from "./systemQuality.vue?vue&type=script&lang=js&"
import style0 from "./systemQuality.vue?vue&type=style&index=0&id=b8cb97f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cb97f6",
  null
  
)

export default component.exports